<template>
    <div class="animation-container" v-show="show">
        <div class="container">
            <div class="row">
                <div class="d-flex flex-wrap justify-content-center text-container">
                    <img class="d-flex" v-if="preloaderLogo && !isAgentPage" :src="url(preloaderLogo)" alt="" />
                    <div class="flex-break"></div>
                    <h1 class="d-flex">{{ headingText }}</h1>
                    <div class="flex-break"></div>
                    <p class="d-flex">{{ paragraphText }}</p>
                </div>

                <Vue3Lottie :animationData="animationData" width="800" />
            </div>
        </div>
    </div>
</template>

<script>
import { replaceColor } from 'lottie-colorify'
import PreloaderAnimation from '@js/components/preloader/monevo-preloader-animation.json'

// lodash components
import trim from 'lodash/trim'

export default {
    props: ['show', 'resubmit', 'isAgentPage'],
    data() {
        return {
            animationData: PreloaderAnimation
        }
    },
    mounted() {
        if (this.show) {
            document.getElementsByTagName('body')[0].classList.add('overflow-hidden')
        }

        const preloaderLineColor = trim(
            window.getComputedStyle(document.documentElement).getPropertyValue('--preloader-line-color'),
        )
        const preloaderBackgroundColor = trim(
            window.getComputedStyle(document.documentElement).getPropertyValue('--preloader-background-color'),
        )

        let recolorAnimation = replaceColor([255, 255, 255], preloaderLineColor, PreloaderAnimation)
        recolorAnimation = replaceColor([31, 80, 152], preloaderBackgroundColor, recolorAnimation)
        recolorAnimation = replaceColor(
            [121, 150, 193],
            this.shadeColor(preloaderBackgroundColor, 80),
            recolorAnimation,
        )

        // there is a certain background colour that cannot be changed by code. So when updating the
        // monevo-preloader-animation.json file, remember to replace "sc":"#1f5098" with
        // "sc":"var(--preloader-background-color)"

        this.animationData = recolorAnimation
    },
    watch: {
        show: function (newVal) {
            if (newVal === false) {
                document.getElementsByTagName('body')[0].classList.remove('overflow-hidden')
            }
        },
    },
    computed: {
        headingText: function () {
            return this.resubmit || this.$route.params.isDirectRoute
                ? this.$t('preloader.resubmit.heading')
                : this.$t('preloader.initialSubmit.heading')
        },
        paragraphText: function () {
            return this.resubmit || this.$route.params.isDirectRoute
                ? this.$t('preloader.resubmit.subText')
                : this.$t('preloader.initialSubmit.subText')
        },
        preloaderLogo: function () {
            if (this.themeSetting('show_preloader_logo') !== '1') {
                return false
            }

            return this.themeSetting('preloader_logo') ?? this.themeSetting('logo')
        },
    },
    methods: {
        shadeColor(color, percent) {
            var R = parseInt(color.substring(1, 3), 16)
            var G = parseInt(color.substring(3, 5), 16)
            var B = parseInt(color.substring(5, 7), 16)

            R = parseInt((R * (100 + percent)) / 100)
            G = parseInt((G * (100 + percent)) / 100)
            B = parseInt((B * (100 + percent)) / 100)

            R = R < 255 ? R : 255
            G = G < 255 ? G : 255
            B = B < 255 ? B : 255

            var RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16)
            var GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16)
            var BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16)

            return `#${RR + GG + BB}`
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.animation-container {
    background-color: var(--preloader-background-color);
    bottom: 0px;
    height: 100vh;
    left: 0px;
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 1000;

    .lottie-container {
        margin: 0 auto;
    }

    .text-container {
        margin-top: 60px;

        @media screen and (min-width: $bp-medium) {
            margin-top: 140px;
        }

        .flex-break {
            flex-basis: 100%;
            width: 0px;
            height: 0px;
            overflow: hidden;
        }

        h1 {
            color: var(--preloader-heading-color);
            font-size: rem(26px);
            font-weight: 600;
            text-align: center;
            margin-bottom: 20px;
        }

        p {
            color: var(--preloader-subheading-color);
            font-family: var(--primary-font);
            font-size: rem(19px);
            margin-bottom: 0;
            text-align: center;
        }

        img {
            margin-bottom: 25px;
            max-height: 100px;
        }
    }
}
</style>
